{
    "Accessibility menu": "Меню доступности",
    "Close": "Закрыть",
    "Text and Reading": "Текст и чтение",
    "Navigation and Interaction": "Навигация и взаимодействие",
    "Text Align": "Выравнивание текста",
    "Align Left": "Выровнять по левому краю",
    "Align Center": "Выровнять по центру",
    "Align Right": "Выровнять по правому краю",
    "Adjust Font Size": "Настроить размер шрифта",
    "Highlight Title": "Выделить заголовок",
    "Highlight Links": "Выделить ссылки",
    "Readable Font": "Читаемый шрифт",
    "Color and Contrast": "Цвет и контраст",
    "Dark Contrast": "Темный контраст",
    "Light Contrast": "Светлый контраст",
    "High Contrast": "Высокий контраст",
    "High Saturation": "Высокая насыщенность",
    "Low Saturation": "Низкая насыщенность",
    "Monochrome": "Монохромный",
    "Tools": "Инструменты",
    "Reading Guide": "Линейка для чтения",
    "Big Cursor": "Большой курсор",
    "Increase Font Size": "Увеличить размер шрифта",
    "Decrease Font Size": "Уменьшить размер шрифта",
    "Letter Spacing": "Межбуквенный интервал",
    "Line Height": "Высота строки",
    "Font Weight": "Насыщенность шрифта",
    "Dyslexia Font": "Шрифт для дислексии",
    "Language": "Язык",
    "Accessibility widget": "Открыть меню доступности",
    "Accessibility Profiles": "Профили доступности",
    "Cognitive Disability": "Когнитивные нарушения",
    "Seizure Safe": "Безопасно при эпилепсии",
    "Accessibility statement": "Заявление о доступности",
    "ADHD": "СДВГ",
    "Low Vision": "Слабое зрение",
    "Pause Animations": "Остановить анимации",
    "Animation paused": "Анимация приостановлена",
    "Reset all settings": "Сбросить настройки",
    "Shortcut:": "Сочетание клавиш:",
    "Epilepsy Safe Mode": "Безопасный режим при эпилепсии",
    "Mute sounds": "Отключить звуки",
    "Page read": "Чтение страницы",
    "Page read controls": "Управление чтением страницы",
    "Pause": "Пауза",
    "Resume": "Продолжить",
    "Stop": "Остановить",
    "Settings": "Настройки",
    "Speed": "Скорость",
    "Voice": "Голос",
    "Close accessibility menu": "Закрыть меню доступности",
    "Back to accessibility menu": "Назад в меню доступности",
    "Search languages": "Поиск языков",
    "Selected language": "Выбранный язык",
    "View accessibility statement (opens in new window)": "Просмотреть заявление о доступности (откроется в новом окне)",
    "Visit CookieYes website (opens in new window)": "Перейти на сайт CookieYes (откроется в новом окне)",
    "Reset all accessibility settings to default": "Сбросить все настройки доступности до значений по умолчанию"
}
